// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { AssetTradingMode, CalculationMethod } from '../Asset/AssetConst.js'
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'
export let DirectAccountStatusMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_ACCOUNT_STATUS)

    this.BstrAccount = null
    this.Email = null
    this.TelephoneNumber = null
    this.FirstName = null
    this.MiddleName = null
    this.LastName = null
    this.UserID = null
    this.UserLogin = null
    this.AllowedRoutes = null

    /// добавили специально для интеграций, храним всякую доп. инфу
    this.AccountDescription = null

    this.AllowOvernightTrading = null

    this.CommisionId = null
    this.SpreadPlanId = null
    this.CrossratesPlanId = null
    this.RiskPlanId = null
    this.SwapPlanId = null
    this.ChargingPlanId = null
    this.FundingRateMarkupPlanId = null
    this.TodayTrades = null

    // UserId того, кто залочил этого пользователя
    this.LockedBy = null

    this.DemoOrLive = -1

    // VISIBILITY_FLAG_OWN = 1 - собственный акаунт
    // VISIBILITY_FLAG_GROUP = 2 - видимость по группе
    // VISIBILITY_FLAG_LINK = 4 - видимость по линке
    // VISIBILITY_FLAG_MAM = 5 - видимость по мам группе
    this.AccountVisibilityFlag = 0

    this.ClientType = 5 // TODO. User.CLIENT_NET
    this.GroupId = -1
    this.FundType = -1
    //this.MaxOrdersPerDay = null
    this.MaxPositions = null
    this.MaxPendingOrders = null

    /// #50403
    this.MaxPendingOrdersValue = null

    this.IsMasterAccount = false

    // +++ AlexB: признак того что юзер подписна сертификатом
    this.IsSigned = false

    this.IntradayRiskManagement = null
    this.AllowTradingOnPrepostMarket = null

    this.TradingLevel = null
    this.WarningLevel = null
    this.MarginLevel = null

    this.TodayVolume = null
    this.TodayTurnover = null

    this.MaxDailyLossLimit = null
    this.MaxDayVolume = null
    this.MaxOrderCapital = null

    this.Status = 1
    this.Role = 0 // TODO. User.ROLE_USER
    this.AccountTradeStatus = null
    this.StopTradingReason = null

    // #49740 - для связи аккаунта с интерест планом
    this.InterestsOnBalancePlanID = null

    this.AssetSharesNames = null

    this.AccountType = null

    this.AssetBalances = []
    this.AssetInfoData = []

    this.pin = null
    this.login = null

    this.AccountAdditionalInfo = null

    this.MaxWeeklyLossLimit = null
    this.TotalMaxPositionsQty = null
    this.MaxUrealizedLossLimit = null

    this.AssetAdditionalInfo = null;
    this.ClusterNode = null;

    this.ExtendedFields = {};

    // #97383
    this.DayTraderPattern = null;
    this.DayTraderPatternProtection = null;
    this.AvailableDayTrades = null;
    this.UserAdditionalInfo = null;

    this.StatisticsGroup = null;
}

DirectAccountStatusMessage.prototype = Object.create(DirectMessageBase.prototype)

Object.defineProperty(DirectAccountStatusMessage.prototype, 'Pin', {
    get: function ()
    {
        return this.pin || this.BstrAccount
    },
    set: function (value)
    {
        this.pin = value
    }
})

Object.defineProperty(DirectAccountStatusMessage.prototype, 'Login', {
    get: function ()
    {
        return this.login || this.BstrAccount
    },
    set: function (value)
    {
        this.login = value
    }
})

export let AssetInfoDataMessage = function ()
{
    // Asset name
    this.Name = ''
    // Total qty
    this.TotalQuantity = 0
    // Today traded qty (передает один раз при логине, лдальше должны расчитывать сами)
    this.TodayTradedQty = 0
    // Qty for margin available
    this.TotalQuantityForMarginAvailable = 0
    // Calculation method (0 - LAST, 1 - PREV_CLOSE)
    this.CalculationMethod = CalculationMethod.Last
    // Режим торговли (General/Delivery)
    this.AssetTradingMode = AssetTradingMode.Delivery
}

export let AssetBalanceMessage = function ()
{
    this.AssetId = 0
    this.AvailableMargin = null
    this.Balance = null
    this.BeginBalance = null
    this.BlockedForOrders = null
    // this.LockedForPAMM = null
    this.BlockedSum = null
    this.CashBalance = null
    this.CreditValue = null
    this.RealizedPnl = null
    this.MaintanceMargin = null
    this.MarginDeficiency = null
    this.MarginSurplus = null
    this.ReservedBalance = null
    this.TodayFees = null
    this.UsedMargin = null
    this.TodayTurnover = null
    this.TodayTrades = null
    this.TodayVolume = null
    this.TodayRebates = null
    this.UnsettledProfit = null
    this.UnsettledLoss = null
    this.TodaySwaps = null
    this.CurrentDailyLoss = null
    this.CurrentWeeklyLoss = null
    this.TrailingDrawdownLevel = null
    this.StockOrdersReq = null
    this.UsedUnsettledNegativePremium = null
    this.UnusedUnsettledNegativePremium = null
    this.UnsettledPositivePremium = null
    this.UnsettledPremiumFromOpenSell = null
    this.UsedPremiumFromOpenSell = null
    this.UnusedPremiumFromOpenSell = null
    this.UsedUnsettledNegativeCashForStocks = null
    this.UnusedUnsettledNegativeCashForStocks = null
    this.UnsettledPositiveCashForStocks = null
    this.StocksLiquidity = null
    this.IsEmpty = false
    this.OptionPremiumReq = null;
    this.UnsettledLossAvailableForWithdrawal = null;
    this.WithdrawableCashForStocks = null;
    this.WithdrawableUnsettledPnL = null;
    this.WaivedMargin = null;
    this.WarningMarginRequirement = null;
    this.MarginBeforeWarning = null;
    this.InitialMarginWithoutWaived = null;

    /// <summary>
    /// #82717
    /// </summary>
    this.UnsettledCollateral = null;
    this.WithdrawableUnsettledCollateral = null;
    this.Collateral = null;

    /// #98161
    this.UnusedSettledCashForStocks = null;
    this.UnusedSettledCollateral = null;
    this.UnsettledDeposit = null;

    /// #98625
    this.UnusedIntradayInitialMargin = null;
    this.UsedOvernightInitialMarginForIntraday = null;

    this.AccruedDividends = null;
    this.MaxRelativeDrawDownLevel = null;

    this.LossLimitPerTrade = null;
    this.WithdrawableOptionsPremium = null

    this.WithdrawalAvailable = null;        // #110792

    this.BuyingPowerAvailableFunds = null   // #106952
}